import React, { useMemo, useState } from 'react';
import styles from './Coach.module.css';
import { resolveMediaUrl } from '../../config/api';

const Coach = ({ firstName, lastName, image, imageUrl, bio, variants, handleSubscribe, userInfo }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const photo = resolveMediaUrl(imageUrl || image);
    const variantCount = variants?.length || 0;

    const summary = useMemo(() => {
        if (!variantCount) {
            return 'No plans published yet.';
        }

        if (variantCount === 1) {
            return '1 training plan available';
        }

        return `${variantCount} training plans available`;
    }, [variantCount]);

    const subscribe = (event, variantId) => {
        event.preventDefault();
        event.stopPropagation();
        handleSubscribe(variantId);
    };

    return (
        <article className={styles.coachCard}>
            <div className={styles.coachHeader}>
                <img src={photo} alt={`${firstName} ${lastName}`} className={styles.coachImage} />
                <div className={styles.coachIdentity}>
                    <span className={styles.coachLabel}>Coach</span>
                    <h3>{`${firstName} ${lastName}`}</h3>
                    <p>{summary}</p>
                    {bio ? <p className={styles.coachBio}>{bio}</p> : null}
                </div>
            </div>

            <button
                type="button"
                className={styles.expandButton}
                onClick={() => setIsExpanded((prev) => !prev)}
            >
                {isExpanded ? 'Hide plans' : 'View plans'}
            </button>

            {isExpanded && (
                <div className={styles.variantsList}>
                    {variants.map((variant) => {
                        const isSubscribed = userInfo?.coachSubscription?.some((sub) => sub.variant_id === variant.id) ?? false;

                        return (
                            <div
                                key={variant.id}
                                className={`${styles.variantCard} ${isSubscribed ? styles.variantCardSubscribed : ''}`}
                            >
                                <div className={styles.variantBody}>
                                    <strong>{variant.name}</strong>
                                    <p>{variant.description}</p>
                                </div>
                                <button
                                    onClick={(event) => subscribe(event, variant.id)}
                                    className={`${styles.subscribeButton} ${isSubscribed ? styles.subscribeButtonDisabled : ''}`}
                                    disabled={isSubscribed}
                                    type="button"
                                >
                                    {isSubscribed ? 'Subscribed' : userInfo ? 'Subscribe' : 'Login to subscribe'}
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}
        </article>
    );
};

export default Coach;
